import { SprintStatus } from '../../../pure-js/enums/SprintStatus'

// Note: INACTIVE status represents draft/unpublished sprints in the backend
export { SprintStatus }

// Legacy alias for backwards compatibility - will be deprecated
// Use SprintStatus directly instead
export type TrainingSprintStatus = SprintStatus
export const TrainingSprintStatus = SprintStatus

export interface SprintTeamDetail {
  teamName: string
  memberNames: string[]
}

export interface TrainingSprint {
  id: string
  title: string
  status: SprintStatus
  duration: string // e.g., "2 weeks"
  sessions: number
  teams: number
  participants: number
  progress: number // percentage 0-100
  startDate?: string
  endDate?: string
  createdAt: string
  updatedAt: string
  teamDetails?: SprintTeamDetail[]
  unassignedMemberNames?: string[]
  facilitatedByUserIds?: string[]
}

export interface TrainingSprintSection {
  id: string
  title: string
  count: number
  isExpanded: boolean
  sprints: TrainingSprint[]
}

export interface TrainingSprintFilters {
  search?: string
  status?: SprintStatus
}
